export default __webpack_public_path__ + "static/media/solution-acc.9014ceee.svg";